<template>
  <div id="app" style="display:flex;flex-direction: column;">
    <div class="scrollbar" v-if="userInfo.UserName && !RegisterFlag.flag && !RegisterFlag.flag2" style="height:100%">
      <Layout></Layout>
    </div>
    <div v-else-if="!userInfo.UserName && !RegisterFlag.flag && !RegisterFlag.flag2" style="height:100%;">
      <Login></Login>
    </div>
    <div v-else-if="RegisterFlag.flag && !RegisterFlag.flag2" style="height:100%;background: #f8f8f9">
      <Register></Register>
    </div>
    <div v-else-if="!RegisterFlag.flag && RegisterFlag.flag2" style="height:100%;background: #f8f8f9">
      <Forget></Forget>
    </div>
    <!--    <Modal v-model="isIE" draggable sticky scrollable :mask="false" title="信息">-->
    <!--      <div>当前浏览器版本过低, 请更换其他浏览器获取更好的体验!</div>-->
    <!--    </Modal>-->
    <!--    <test-json style="z-index: 9999999"></test-json>-->
  </div>
</template>

<script>
import Layout from "./pages/Layout";
import Login from "./pages/Login";
import Register from "./pages/Register";

import {mapMutations, mapState} from "vuex";
import axios from "@/api/axios";
import store from "@/store";
import router from "@/router";
import Forget from "./pages/forget";

export default {
  name: "App",
  components: {
    Forget,
    Layout,
    Login,
    Register,
  },
  data() {
    return {
      //isIE: false
    }
  },
  computed: {
    ...mapState(["userInfo", 'RegisterFlag', 'forgetFlag']),
  },
  created() {
     axios
        .get("/api/userstate")
        .then(response => {
          //console.log(response)
          if (response.data.status) {
            //防止vuex中的数据丢失,
            // 在页面加载时读取sessionStorage里的数据
            if (sessionStorage.getItem("store")) {
              this.$store.replaceState(Object.assign({}, this.$store.state, JSON.parse(sessionStorage.getItem("store"))))
            }
            //在页面刷新时将vuex中的信息保存到sessionStorage中
            window.addEventListener("beforeunload", () => {
              sessionStorage.setItem("store", JSON.stringify(this.$store.state))
            })
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    // 在页面加载时读取sessionStorage里的状态信息
    if (sessionStorage.getItem("store")) {
      this.$store.replaceState(Object.assign({}, this.$store.state, JSON.parse(sessionStorage.getItem("store"))))
    }
    // 在页面刷新时将vuex里的信息保存到sessionStorage里

  },
  mounted() {
    // const userAgent = navigator.userAgent; //取得浏览器的userAgent字符串
    // // 判断是否IE浏览器
    // if (userAgent.indexOf("Trident") > -1) {
    //   this.isIE = true;
    // }
  }
};
</script>

<style>
.layout-content {
  flex: auto;
}

#app {
  height: 100%;
}

@media (max-width: 1000px) {
  #app {
    width: 1024px !important;
  }

  #login {
    /*overflow-x: scroll !important;*/
    width: 1024px !important;
  }
}

.scrollbar {
  overflow-y: auto;
  overflow-x: hidden;
}

.scrollbar::-webkit-scrollbar {
  width: 10px;
  height: 8px;
}

.scrollbar::-webkit-scrollbar-thumb {
  border-radius: 20px;
  /*-webkit-box-shadow: inset 0 0 10px rgba(0,0,0,0.2);*/
  background: rgba(0, 0, 0, 0.2);
}

.scrollbar::-webkit-scrollbar-thumb:hover {
  border-radius: 20px;
  background: rgba(0, 0, 0, 0.3);
}

.scrollbar::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 2px rgba(0, 0, 0, 0);
  border-radius: 30px;
  background: rgba(0, 0, 0, 0);
}

.scrollbar::-webkit-scrollbar-track:hover {
  -webkit-box-shadow: inset 0 0 2px rgba(0, 0, 0, 0.2);
  border-radius: 30px;
  background: rgba(0, 0, 0, 0.1);
}


</style>
